import request from '@/plugins/axios'

//获取图片库列表
export function listLib(params) {
  return request({
    url: '/lib/listLib',
    method: 'get',
    params
  })
}

//添加图片库
export function addLib(data) {
  return request({
    url: '/lib/addLib',
    method: 'post',
    data
  })
}

//删除图片库
export function deleteLib(params) {
  return request({
    url: '/lib/deleteLib/' + params,
    method: 'get'
  })
}

//查询单个图片库
export function getLib(params) {
  return request({
    url: '/lib/getLib/' + params,
    method: 'get'
  })
}

//修改图片库信息
export function updateLib(data) {
  return request({
    url: '/lib/updateLib',
    method: 'post',
    data
  })
}

//获取已授权图库列表
export function listMyPowerLib() {
  return request({
    url: '/lib/listMyPowerLib',
    method: 'get'
  })
}